import tw, { styled, css } from 'twin.macro'

export type Props = {
  href?: string
  rel?: string
}

const disabledStyle = css`
  opacity: 0.4;
  cursor: default;
`

const Container = styled.a<Props>`
  ${tw`flex items-center`}

  font-size: 12px;
  line-height: 1;
  letter-spacing: 1px;
  cursor: pointer;

  * + * {
    margin-left: 4px;
  }

  svg {
    width: 12px;
    height: 12px;
    ${tw`hidden md:block`};
  }

  ${(props) => !props.href && disabledStyle}
`

export default Container
